module.exports = __webpack_public_path__ + "img/trebel-mobile-navigation.ea883e5.png";